import React from 'react';
import Markdown from '../../Markdown';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import MuiFormGroup from '@material-ui/core/FormGroup';
import styled from 'styled-components/macro';
import Tooltip from '@material-ui/core/Tooltip';

export const FormGroup = styled(MuiFormGroup)`
  && {
    max-height: 230px;
    overflow-y: auto;
    flex-wrap: initial;
  }
`;

export const FormControlLabel = styled(MuiFormControlLabel)`
  [class*='MuiTypography-root'] {
    font-size: 14px;
    margin: 0.8em 0;
  }
`;

const MultiSelectFieldView = props => {
  return (
    <FormGroup>
      {Array.from(props.data).map(([value, isChecked]) => (
        <Tooltip
          title={value ? props.tooltips[value] || '' : ''}
          placement="left"
          arrow
        >
          <FormControlLabel
            key={value}
            control={
              <Checkbox
                disabled={props.readOnly}
                checked={isChecked}
                onChange={props.onChecked}
                name={value}
                color="primary"
                data-testid={`multiselect-${props.internalId}-${value}`}
              />
            }
            label={<Markdown 
              content={value}
              allowedTypes={[
                'root',
                'text',
                'strong',
                'emphasis',
                'link',
                'image',
                'paragraph',
                'break'
              ]}           
              />}
          />
        </Tooltip>
      ))}
    </FormGroup>
  );
};

export default MultiSelectFieldView;
